import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=63493dbe&scoped=true&"
import script from "./chatForm.vue?vue&type=script&lang=js&"
export * from "./chatForm.vue?vue&type=script&lang=js&"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=63493dbe&prod&scoped=scoped&lang=scss&"
import style1 from "./chatForm.vue?vue&type=style&index=1&id=63493dbe&prod&lang=scss&"
import style2 from "./chatForm.vue?vue&type=style&index=2&id=63493dbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63493dbe",
  null
  
)

export default component.exports